"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[error-boundary]", error);
  }, [error]);

  return (
    <div className="bg-warm-bg min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <p className="text-6xl font-bold text-forest mb-4">Oops</p>
        <h1 className="font-serif text-2xl font-bold text-charcoal mb-3">
          Something went wrong
        </h1>
        <p className="text-text-muted text-sm mb-8">
          Sorry, this page hit a snag. It is not you, it is us. Try again, or head
          back to find a tradesperson.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={reset}
            className="inline-flex items-center justify-center px-6 py-3 bg-forest text-white font-semibold rounded-sm hover:bg-forest-light transition-colors text-sm"
          >
            Try again
          </button>
          <Link
            href="/browse"
            className="inline-flex items-center justify-center px-6 py-3 border border-forest text-forest font-semibold rounded-sm hover:bg-forest/5 transition-colors text-sm"
          >
            Find a tradesperson
          </Link>
        </div>
      </div>
    </div>
  );
}
